import GL from "_src/engine/gl";
import { uniformSource } from "_src/engine/constants";

class Uniform {

  constructor(type, value, source = uniformSource.SHADER) {
    this.type = type;
    this.value = value;
    this.location = null; // assigned after shader compilation
    this.source = source;

    this._setter = GL.getUniformSetter(type);
  }

  commit() {
    this._setter(this.location, this.value);
  }

}

export default Uniform;
